@if (opportunityEstimates().length === 0) {
    <lib-no-data
        [iconName]="isManualOrDisqualified() ? 'forbidden' : 'empty'"
        [title]="emptyStateTitle()"
        [linkText]="emptyStateLink()"
        (linkAction)="isManualOrDisqualified() ? navigateTo('Overview') : createBaseEstimate()"
    >
    </lib-no-data>
} @else {
    @if (opportunityEstimates() && opportunityEstimates()[0].opportunityStatusId === requestedStatus()) {
        <lib-no-data
            [iconName]="'requested'"
            [title]="'You already requested a bid from a template.'"
            text="We are building it. Please check back later or"
            linkText="refresh for updates."
            (linkAction)="refreshPage()"
        >
        </lib-no-data>
    } @else {
        @if (showSummary()) {
            <app-estimates-summary
                [estimateId]="finalEstimateId()"
                (goBackClicked)="showSummary.set($event)"
            ></app-estimates-summary>
        } @else {
            @if (opportunityEstimates().length !== 0) {
                <lib-tab-view
                    [currentTab]="currentTab()"
                    (currentTabChange)="currentTab.set($event)"
                    direction="column"
                    alignment="start"
                    separation="narrow"
                    [fixedContentHeader]="headerTemplate"
                >
                    <ng-template #headerTemplate>
                        <app-estimates-sub-header
                            [opportunityEstimates]="opportunityEstimates()"
                            (clicked)="showSummary.set($event)"
                        ></app-estimates-sub-header>
                    </ng-template>

                    <lib-tab-item
                        tabName="Final Estimates"
                        [bodyTemplate]="finalEstimatesTab"
                        [icon]="finalEstimatesIcon()"
                    >
                        <ng-template #finalEstimatesTab>
                            <app-estimates-grid
                                [opportunityId]="opportunityId()"
                                [isFinalEstimate]="true"
                            ></app-estimates-grid>
                        </ng-template>
                    </lib-tab-item>

                    <lib-tab-item
                        tabName="Alternate Estimates"
                        [bodyTemplate]="alternateEstimatesTab"
                        [icon]="alternateEstimatesIcon()"
                    >
                        <ng-template #alternateEstimatesTab>
                            <app-estimates-grid [opportunityId]="opportunityId()"></app-estimates-grid>
                        </ng-template>
                    </lib-tab-item>

                    <lib-tab-item tabName="Change Order" [bodyTemplate]="changeOrderTab" [icon]="changeOrderIcon()">
                        <ng-template #changeOrderTab>
                            <app-estimates-change-order-grid
                                [opportunityId]="opportunityId()"
                            ></app-estimates-change-order-grid>
                        </ng-template>
                    </lib-tab-item>
                </lib-tab-view>
            }
        }
    }
}
